export const drawerBodyInjectionKey = Symbol('drawerBody');
export const drawerInjectionKey = Symbol('drawer');
